const isAppleDevice = () => {
    const userAgent = window.navigator.userAgent;
    return /Mac|iPod|iPhone|iPad/.test(userAgent);
};

export default isAppleDevice;
